import React from 'react';
import './Skills.css';

function Skills() {
  return (
    <div>
      <h2 className='h2'>Skills</h2>
      <div className='skill'>
        <p className='python'>Python</p>
        <p className='cpp'>Machine Learning</p>
        <p className='php'>Deep Learning</p>
        <p className='next'>NLP</p>
        <p className='node'>Computer Vision</p>
        <p className='c'>Data Analysis</p>
        <p className='fb'>Data Visualization</p>
        <p className='java'>RAG</p>
        <p className='html'>HTML</p>
        <p className='css'>CSS</p>
        <p className='js'>JavaScript</p>
        <p className='react'>React.js</p>
        <p className='mysql'>MySQL</p>
      </div>
    </div>
  )
}

export default Skills
